import { apiClient } from './apiClient';
import { API_ENDPOINTS } from '../config/api';

export const analyticsService = {
  fetchStats: () => {
    return apiClient.get(API_ENDPOINTS.analytics.stats);
  },
};